<template>
  <div class="flex flex-wrap">
    <Detail :showModal="showModalDetail" :toggleModal="toggleModalDetail"
      :clientNamesProps="filterClients['client_name']" />
    <div v-if="showModal" class="opacity-25 fixed inset-0 z-40 bg-black"></div>
    <div v-if="showModalDetail" class="opacity-25 fixed inset-0 z-40 bg-black"></div>
    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    <div class="w-full px-4">
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div class="rounded-t bg-white mb-0 px-6 py-6">
          <div class="text-center flex justify-between">
            <h6 class="text-blueGray-700 text-xl font-bold">API Management</h6>
            <div>
              <a class="bg-cyan-500 text-white active:bg-cyan-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                href="/admin/api-management/bulk">
                Bulk Upload
              </a>
              <a class="bg-indigo-500 text-white active:bg-indigo-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                v-on:click="toggleModalDetail" href="#">
                Clone API
              </a>
              <a class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                v-on:click="onClickAdd" href="#">
                Create New
              </a>

            </div>
          </div>
          <br />
          <hr />
          <div class="text-center flex justify-between py-6">
            <div class="w-full lg:w-12/12 flex flex-wrap">
              <div class="w-full lg:w-2/12 mr-3">
                <label class="block text-sm font-medium text-gray-700 mb-2">Client Name</label>
                <select v-model="filter.client_name"
                  class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  @change="getAppNames()">
                  <option v-for="(item, key) in filterClients['client_name']" :value="item" :key="key">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="w-full lg:w-2/12 mr-3">
                <label class="block text-sm font-medium text-gray-700 mb-2">App Name</label>
                <select v-model="filter.app_name"
                  class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  @change="getVersions()">
                  <option v-for="(item, key) in filterClients['app_name']" :value="item" :key="key">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="w-full lg:w-2/12 mr-3">
                <label class="block text-sm font-medium text-gray-700 mb-2">Version</label>
                <select v-model="filter.version"
                  class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  @change="getIntentions()">
                  <option v-for="(item, key) in filterClients['version']" :value="item" :key="key">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="w-full lg:w-2/12 mr-3">
                <label class="block text-sm font-medium text-gray-700 mb-2">Intention</label>
                <select v-model="filter.intention"
                  class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                  <option v-for="(item, key) in filterClients['intention']" :value="item" :key="key">
                    {{ item }}
                  </option>
                </select>
              </div>
              <a class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-3 mt-7 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                @click="search()">
                Search
              </a>
              <a class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-3 mt-7 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                @click="clear()">
                Clear
              </a>
              <a class="bg-cyan-500 text-white active:bg-cyan-600 font-bold uppercase text-xs px-4 py-3 mt-7 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                @click="setupExport()" v-if="!isExport">
                Setup Export
              </a>
              <export-excel
                class="bg-cyan-500 text-white active:bg-cyan-600 font-bold uppercase text-xs px-4 py-3 mt-7 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                :data="dataExport" name="api-management.xls" v-if="isExport">
                Export
              </export-excel>
            </div>
          </div>
        </div>
        <div class="block w-full overflow-x-auto">
          <!-- Projects table -->
          <table class="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  ID
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Client Name
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  App Name
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Version
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Intention
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in clients" :key="item.id" data-bs-toggle="tooltip" :title="JSON.stringify({
                parameters: item.query_param, method: item.method, description: item.description
              }, null, 2)">
                <th class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
                  {{ item.id }}
                </th>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.client_name }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.app_name }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.version }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.intention }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  <router-link :to="'/admin/api-management/' + item.id + '/use'"
                    class="bg-cyan-500 text-white active:bg-cyan-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">Use</router-link>
                  <router-link :to="'/admin/api-management/' + item.id"
                    class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">Detail</router-link>
                  <router-link :to="'/admin/api-management/' + item.id + '/edit'"
                    class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">Edit</router-link>
                  <a href="#" v-on:click="deleteItem(item)"
                    class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">Delete</a>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination :totalCounts="totalCounts" :onPageChange="handlePageChange" />

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import APIDataService from "@/services/APIDataService";
import FilterDataService from "@/services/FilterDataService";
import { UseAppStore } from '@/stores/AppStore';
import Detail from "@/views/admin/api-management/Detail.vue";
import Pagination from "@/components/Paginate/Pagination.vue";
import ConfirmDialogue from "@/components/ConfirmDialogue/ConfirmDialogue.vue";
import constants from "@/constants";
import ErrorHandler from "@/ErrorHandler";

export default {
  setup() {
    const appStore = UseAppStore();

    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("api-management", "API Management", "/admin/api-management")
    return {
      appStore
    }
  },
  components: {
    Detail,
    Pagination,
    ConfirmDialogue
  },
  data() {
    return {
      totalCounts: 0,
      clients: [],
      currentClient: {
        id: null,
        clientName: "",
        version: "",
        authToken: ""
      },
      currentIndex: -1,
      showModal: false,
      showModalDetail: false,
      alertType: '',
      alertMessage: '',
      pageType: 'Add',
      itemID: '',
      filter: {},
      filterClients: {},
      isExport: false,
      dataExport: []
    }
  },
  methods: {
    setupExport() {
      var payload = this.filter
      if (this.isExport) {
        payload['limit'] = 0
        APIDataService.search(payload)
          .then(response => {
            this.dataExport = response.data["data"]["apis"];

          })
          .catch(e => {
            ErrorHandler(e);
          });
      } else {
        this.isExport = true

        payload['limit'] = 0
        APIDataService.search(payload)
          .then(response => {
            this.dataExport = response.data["data"]["apis"];

          })
          .catch(e => {
            ErrorHandler(e);
          });
      }
    },
    handlePageChange(page) {
      var payload = this.filter
      payload['limit'] = constants.pageLimit
      payload['page'] = page
      APIDataService.search(payload)
        .then(response => {
          this.clients = response.data["data"]["apis"];

        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    countDownTimer(countDown, callback) {
      if (countDown > 0) {
        setTimeout(() => {
          countDown -= 1
          this.countDownTimer(countDown, callback)
        }, 1000)
      } else {
        this.alertType = ''
        if (callback != undefined) {
          callback()
        }
      }
    },
    toggleModal() {
      this.showModal = !this.showModal;
    },
    toggleModalDetail() {
      this.showModalDetail = !this.showModalDetail;
    },
    onClickAdd() {
      this.currentClient = {
        id: null,
        clientName: "",
        version: "",
        authToken: ""
      };
      this.showModal = !this.showModal;
      this.pageType = 'Add'
      this.$router.push(`/admin/api-management/new`)
    },
    retrieveApis() {
      APIDataService.getAll()
        .then(response => {
          this.clients = response.data["data"]["apis"];
          this.totalCounts = response.data["data"]["count"];
          console.log(response.data);
        })
        .catch(e => {
          ErrorHandler(e);
        });
      this.getClientNames()
    },
    getClientNames() {
      this.filter = {}
      this.filterClients['app_name'] = []
      this.filterClients['version'] = []
      FilterDataService.search(this.filter)
        .then(response => {
          this.filterClients['client_name'] = response.data["data"]["list"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    getAppNames() {
      this.filter = {
        client_name: this.filter.client_name
      }
      this.filterClients['version'] = []
      FilterDataService.search(this.filter)
        .then(response => {
          this.filterClients['app_name'] = response.data["data"]["list"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    getVersions() {
      this.filter = {
        client_name: this.filter.client_name,
        app_name: this.filter.app_name,
      }
      this.filterClients['intention'] = []
      FilterDataService.search(this.filter)
        .then(response => {
          this.filterClients['version'] = response.data["data"]["list"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    getIntentions() {
      this.filter = {
        client_name: this.filter.client_name,
        app_name: this.filter.app_name,
        version: this.filter.version
      }
      FilterDataService.search(this.filter)
        .then(response => {
          this.filterClients['intention'] = response.data["data"]["list"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    search() {
      APIDataService.search(this.filter)
        .then(response => {
          this.clients = response.data["data"]["apis"];
          this.totalCounts = response.data["data"]["count"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    clear() {
      this.filter = {}
      this.filterClients = {}
      this.isExport = false
      this.retrieveApis();
    },
    refreshList() {
      this.retrieveApis();
      this.currentClient = null;
      this.toggleModal()
    },

    editClient(item, index) {
      this.currentClient = {
        id: item.id,
        clientName: item.client_name,
        version: item.version,
        authToken: item.auth_token
      };
      console.log(this.currentClient)
      this.currentIndex = item ? index : -1;
      this.showModal = !this.showModal;
      this.pageType = 'Edit'
    },
    showClient(item) {
      // APIDataService.get(item.id)
      //   .then(response => {
      //     this.currentClient = response.data["data"]["apis"][0]
      this.itemID = item.id;
      this.showModalDetail = !this.showModalDetail;
      // })
      // .catch(e => {
      //   console.log(e);
      // });        
    },
    async deleteItem(item) {
      const ok = await this.$refs.confirmDialogue.show({
        title: 'Attention',
        message: 'Are you sure you want to delete this item?',
        okButton: 'Delete',
      })

      if (ok) {
        APIDataService.delete(item.id)
          .then(() => {
            this.alertType = 'Success'
            this.alertMessage = 'API Management successfuly deleted'
            this.countDownTimer(3, this.retrieveApis)
          })
          .catch(e => {
            ErrorHandler(e);
          });
      }
    },
    searchClient() {
      APIDataService.findByTitle(this.title)
        .then(response => {
          this.clients = response.data;
          this.editClient(null);
          console.log(response.data);
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    onSubmit(client) {
      if (this.currentClient != null && this.currentClient.id != null) {
        this.updateClient(client)
      } else if (this.currentClient != null && this.currentClient.id == null) {
        this.addClient(client)
      }

    },
    addClient(client) {
      var data = {
        client_name: client.clientName,
        version: client.version,
        auth_token: client.authToken
      };
      APIDataService.create(data)
        .then(() => {
          this.alertType = 'Success'
          this.alertMessage = 'Client successfuly created'
          this.countDownTimer(3, this.refreshList)
        })
        .catch(e => {
          this.alertType = 'Failed'
          this.alertMessage = e.response.data.code_message
          this.countDownTimer(3)
        });
    },
    updateClient(client) {
      var data = {
        client_name: client.clientName,
        version: client.version,
        auth_token: client.authToken
      };
      APIDataService.update(this.currentClient.id, data)
        .then(() => {
          this.alertType = 'Success'
          this.alertMessage = 'Client successfuly updated'
          this.countDownTimer(3, this.refreshList)
        })
        .catch(e => {
          this.alertType = 'Failed'
          this.alertMessage = e.response.data.code_message
          this.countDownTimer(3)
        });
    }
  },
  mounted() {
    this.retrieveApis();
  }
};
</script>
